import {useTranslation} from "react-i18next";
import {Col, Form, Row} from "react-bootstrap";
import {Block, BoolSelect, FormGroup, Select} from "../components";
import React from "react";

export default function DevicesForm({formData, getInputProps, disabled}) {
  const { t } = useTranslation();

  return (
    <Block title={t("stream.device")}>
      <FormGroup label={t("stream.os")} {...getInputProps("os")}>
        <Select isClearable={true} placeholder={t("stream.anyOs")}>
          <Option value="ios">iOS</Option>
          <Option value="android">Android</Option>
        </Select>
      </FormGroup>
      <FormGroup input={BoolSelect} label={t("stream.idfaRequired")} {...getInputProps("idfa_required")}/>
      <Form.Row>
        <FormGroup input={BoolSelect} as={Col} label={t("stream.homeRequired")} {...getInputProps("home_required")} />
        <FormGroup input={BoolSelect} as={Col} label={t("stream.workRequired")} {...getInputProps("work_required")} />
      </Form.Row>
    </Block>)
}
